<div id="sub-header">
  <nav>
    <h2>Select entity</h2>
    <mat-button-toggle-group name="selectDuplikitEntity" aria-label="Select entity buttons" hideSingleSelectionIndicator="true">
      <mat-button-toggle
        *ngFor="let entity of entities"
        (change)="onEntitySelected(entity.name)"
        [ngClass]="[entity.name === selectedEntity ? 'selected': '', entity ? getClassNameForEntity(entity.name) : '']">
        <i [ngClass]="renderIcon(entity.name)"></i>
        {{entity.name}}
        <aside *ngIf="entity.total === null">
          <span class="input-loading-spinner spinner-border spinner-border-sm"></span>
        </aside>
        <aside *ngIf="entity.total !== null" [matTooltip]="'Number of master ' + entity.name + ' records merged'">
          {{ entity.total }}
        </aside>
        <aside [ngClass]="[entity.queued>0?'merge-in-progress':'']" *ngIf="entity.queued > 0" [matTooltip]="'Number of duplicate ' + entity.name + ' records queued for merge'">
          {{ entity.queued }}
        </aside>
      </mat-button-toggle>
    </mat-button-toggle-group>
  </nav>
</div>

<div class="content">
  <article>
    <h2 class="heading-underline">
      <div class="back-button" (click)="goToApp(DataToolsApps.DUPLIKIT)">
        <i class="bhi-previous"></i>
        <span>Back to {{DataToolsAppsTitles.DUPLIKIT}}</span>
      </div>
      Review and revert history of {{DataToolsAppsTitles.DUPLIKIT}} merges
      <span class="sub-info">
        <ng-container [ngSwitch]="this.dataSource.data.length">
          <ng-container *ngSwitchCase="0"></ng-container>
          <ng-container *ngSwitchCase="1">Retrieved 1 merge</ng-container>
          <ng-container *ngSwitchDefault>Retrieved {{ this.dataSource.data.length }} most recent records</ng-container>
        </ng-container>
      </span>
    </h2>

    <div *ngIf="mergeHistoryLoading" class="app-loading">
      <svg class="spinner" viewBox="25 25 50 50">
        <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="3" stroke-miterlimit="10"/>
      </svg>
    </div>

    <button id="clearFilters" (click)="clearFiltersAndReload()" *ngIf="anyActiveFilter()">
      <i class="bhi-times"></i>Clear Filters
    </button>

    <table mat-table [dataSource]="dataSource" class="table-striped" matSort matSortActive="date" id="history_table"
           matSortDirection="desc">
      <ng-container matColumnDef="masterId">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Master ID</th>
        <td mat-cell *matCellDef="let dedupeTask">{{dedupeTask.masterId}}</td>
      </ng-container>
      <ng-container matColumnDef="duplicates">
        <th mat-header-cell *matHeaderCellDef>
          Duplicates
        </th>
        <td mat-cell *matCellDef="let dedupeTask">
          <ul class="listOfDuplicates">
            <li *ngFor="let duplicate of dedupeTask.duplicates.split(',')">
              {{ duplicate }}
            </li>
            <li class="showDuplicateDetails">
              <i class="bhi-more"></i>
              <a (click)="showMergeLogs(dedupeTask.id)">Show full details</a>
            </li>
          </ul>
        </td>
      </ng-container>
      <ng-container matColumnDef="userId">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>User ID</th>
        <td mat-cell
            *matCellDef="let dedupeTask">{{ dedupeTask.userId === -1 ? 'Scheduler' : (dedupeTask.userId === 0 ? 'Unknown' : dedupeTask.userId) }}
        </td>
      </ng-container>
      <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          Date
          <i class="bhi-question" [matTooltip]="'Date of last merge to this master record.'"></i>
        </th>
        <td mat-cell *matCellDef="let dedupeTask">{{dedupeTask.endDate | date:'medium'}}</td>
      </ng-container>
      <ng-container matColumnDef="state">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let dedupeTask" class="state_cell">
          <button theme="small" *ngIf="canRevert(dedupeTask)"
                  (click)="unDedupeByDedupeTaskId(dedupeTask)"
                  [disabled]="aRevertIsInProgress() || this.duplikitMergeService.anyEntityIsMerging()">
            <span class="revert"></span>
            <span>Revert</span>
          </button>
          <span *ngIf="dedupeTask.state === 'RUNNING'">MERGING</span>
          <span *ngIf="dedupeTask.state === 'REVERTING' || isUnDeduping(dedupeTask)">REVERTING</span>
          <span *ngIf="dedupeTask.state === 'REVERTED'">REVERTED</span>
          <span *ngIf="dedupeTask.state === 'FAILED'">FAILED</span>
          <span *ngIf="dedupeTask.state === 'CANCELLED'">CANCELLED</span>
          <span *ngIf="dedupeTask.state === 'CREATED' || dedupeTask.state === 'QUEUED' ">QUEUED</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="masterId_filter">
        <th mat-header-cell *matHeaderCellDef>
          <input type="number" #masterIdValue class="bullhornIdFilter" min="1" autofocus matInput
                 onfocus="this.select()"
                 (keyup)="updateFilter('masterId', masterIdValue.value)"
                 [matTooltip]="'Enter full ' + selectedEntity + ' ID.'"
                 placeholder="Enter ID">
        </th>
      </ng-container>
      <ng-container matColumnDef="duplicates_filter">
        <th mat-header-cell *matHeaderCellDef>
          <input type="number" #duplicateIdValue class="bullhornIdFilter" min="1" matInput onfocus="this.select()"
                 (keyup)="updateFilter('duplicateId', duplicateIdValue.value)"
                 [matTooltip]="'Search for one ' + selectedEntity + ' ID.'"
                 placeholder="Enter ID">
        </th>
      </ng-container>
      <ng-container matColumnDef="userId_filter">
        <th mat-header-cell *matHeaderCellDef>
          <input type="number" #userIdValue class="bullhornIdFilter" min="1" matInput onfocus="this.select()"
                 (keyup)="updateFilter('userId', userIdValue.value)"
                 [matTooltip]="'Search for one ' + selectedEntity + ' ID.'"
                 placeholder="Enter ID">
        </th>
      </ng-container>
      <ng-container matColumnDef="date_filter">
        <th mat-header-cell *matHeaderCellDef id="datePicker">
          <div class="datepicker-container">
            <input matInput #dateSortValue  [matDatepicker]="picker_dateAddedBefore" placeholder="dd/mm/yyyy"
                   (click)="picker_dateAddedBefore.open()"
                   (dateChange)="updateFilter('date', dateSortValue.value)">
            <mat-datepicker-toggle matSuffix [for]="picker_dateAddedBefore"></mat-datepicker-toggle>
            <mat-datepicker #picker_dateAddedBefore></mat-datepicker>
          </div>
          <i class="bhi-times" *ngIf="inputFilterData.date !== null" (click)="resetDateFilter()"
             [matTooltip]="'Remove date filter'"></i>
        </th>
      </ng-container>
      <ng-container matColumnDef="mergerUserId_filter">
        <th mat-header-cell *matHeaderCellDef>
          <input type="number" min="1" #sortValue (keyup)="updateFilter('mergerUserId', sortValue.value)">
        </th>
      </ng-container>
      <ng-container matColumnDef="state_filter">
        <th mat-header-cell *matHeaderCellDef>
          <!-- empty for state TODO: maybe we want to allow a filter on this? -->
        </th>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-header-row *matHeaderRowDef="filterColumns"></tr>
      <tr [hidden]="mergeHistoryLoading" mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <div [hidden]="mergeHistoryLoading">
      <div *ngIf="dataSource.data.length === 0" class="no-results">
        No merge records returned.
      </div>
      <mat-paginator [hidePageSize]="true" showFirstLastButtons [pageSize]="pageSizeOptions[0]"></mat-paginator>
      <span class="currentPageDetails" *ngIf="dataSource.data.length > 0">
        Page {{ paginator.pageIndex + 1 }} of {{ paginator.getNumberOfPages() }}
      </span>
    </div>

  </article>
</div>
